import React, { useEffect, useRef, useState } from "react";
import BLOG_IMAGE from "../assets/Vector_2640.jpg";
import AVATAR from "../assets/jurica-koletic-7YVZYZeITc8-unsplash.jpg";
import LINE from "../assets/Line12.svg";
import MOUSE_DOWN from "../assets/8167-simple-scroll-down-icon.gif";
//Fontawesome imports
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";

function HeroSection(props) {
  useEffect(() => {
    if (props.hideScroller == true) {
      console.log(props.hideScroller);
      document.querySelector(".custom-mouse-wheel").style.display = "none";
    }
  });
  const backgroundImageStyles = {
    background: `linear-gradient( rgba(0, 0, 0, 0.6) 100%, rgba(0, 0, 0, 0.5)100%),url(${BLOG_IMAGE}),no-repeat`,
    height: "100vh",
    width: "100vw",
  };
  return (
    <div className="custom-hero-section-container">
      <div
        className="custom-hero-section-image-container"
        style={backgroundImageStyles}
      >
        <div className="row custom-hero-section-content-exterior-container">
          <div className="custom-hero-section-content-container d-flex col-xl-11">
            <h1>The Future of Big Data</h1>
            <div className="border-bottom"></div>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Hic
              pariatur, dolores magni vel accusamus labore iste suscipit
              distinctio voluptatem vero consequuntur nisi illo ad, nam aperiam
              incidunt. Molestiae, error ad! Voluptatibus perferendis illo illum
              aliquid reiciendis placeat maxime architecto quidem rem earum
              facilis eligendi molestias nulla, praesentium.
            </p>
            <div className="d-flex">
              <img src={AVATAR} alt="" />
              <div className="d-flex flex-column">
                <span>
                  <b>James Smith</b>
                </span>
                <span>Big Data Engineer @ Voxitech</span>
              </div>
            </div>
            <span style={{ fontSize: "14px", marginTop: "20px" }}>
              Published: Feb 02, 2022
            </span>
          </div>
          <div
            style={{ color: "white" }}
            className="col-xl-1 custom-hero-section-links d-flex"
          >
            <img className="custom-dotted-line" src={LINE} alt="dotted-line" />

            <div className="d-flex mt-4 custom-hero-section-links-container">
              <TwitterIcon
                style={{ marginTop: "50px", cursor: "pointer" }}
                sx={{ fontSize: 40 }}
              />
              <LinkedInIcon
                style={{ marginTop: "50px", cursor: "pointer" }}
                sx={{ fontSize: 40 }}
              />
              <FacebookIcon
                style={{
                  marginTop: "50px",
                  cursor: "pointer",
                }}
                sx={{ fontSize: 40 }}
              />
            </div>
          </div>
        </div>
        <img className="custom-mouse-wheel" src={MOUSE_DOWN} alt="" />
      </div>
    </div>
  );
}
export default HeroSection;
